import { captureChatOwner } from './creation-actions';
import { ownsMessageKey } from './message-cache';
import type { QueryClient } from '@tanstack/react-query';
import type { Channel } from './queries';
import { useChatDockStore } from './chat-dock-store';
import { useTeamChatLiveAlertStore } from './live-alert-store';
import { sessionRevision, sessionScope } from '@/features/auth/session-scope';
import { useAuthStore } from '@/store/auth-store';

/** Used by both a successful leave and a self-removal received in another tab. */
export async function removeLeftChannel(client: QueryClient, channelId: string) {
  const owner=captureChatOwner();
  const revision = sessionRevision();
  const key = ['team-chat', 'channels', 'owner', sessionScope(useAuthStore.getState()), revision];
  await client.cancelQueries({ queryKey: key });
  if (revision !== sessionRevision()) return;
  client.setQueriesData<Channel[]>({ queryKey: key }, (channels) =>
    channels?.filter((channel) => channel.id !== channelId),
  );
  client.removeQueries({predicate:query=>ownsMessageKey(query.queryKey,owner)&&
    (query.queryKey[2]===channelId||query.queryKey[1]==='thread'||query.queryKey[1]==='tracked-threads')});
  client.removeQueries({queryKey:['team-chat','members',channelId,'owner',owner.scope,owner.revision]});
  const dock = useChatDockStore.getState();
  dock.closeChat(channelId);
  if (dock.openInFullView === channelId) dock.setOpenInFullView(null);
  useTeamChatLiveAlertStore.getState().acknowledge(channelId);
  // Keep the filtered result visible while refreshing from the server.
  void client.invalidateQueries({ queryKey: key });
}
